import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Home
import Inicio from './views/home/Inicio';

// Busqueda
import Busqueda from './views/home/Busqueda';

// Recibo
import Recibo from './views/home/Recibo';

// Redux
import store from './store';

function App() {
	let token = false;

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout>
						<Alert></Alert>

						<Routes>
							{/* Home */}
							<Route exact path="/" element={<ValidateSession isToken={token}><Inicio /></ValidateSession>}/>

							{/* Búsqueda */}
							<Route exact path="/busqueda" element={<ValidateSession isToken={token}><Busqueda /></ValidateSession>}/>

							{/* Recibo */}
							<Route exact path="/recibo/:folio" element={<ValidateSession isToken={token}><Recibo /></ValidateSession>}/>
							
							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</Layout>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;